export default `<svg width="400" height="160" viewBox="0 0 400 160" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="1.17773" y="1.44202" width="397.236" height="156.725" rx="9" fill="white" stroke="black" stroke-width="2"/>
<path d="M56.957 59.0365H341.377" stroke="black" stroke-width="4" stroke-linecap="round"/>
<path d="M56.957 42.468H341.377" stroke="black" stroke-width="4" stroke-linecap="round"/>
<path d="M56.957 77.4822H341.377" stroke="black" stroke-width="4" stroke-linecap="round"/>
<path d="M56.957 95.9277H341.377" stroke="black" stroke-width="4" stroke-linecap="round"/>
<path d="M56.957 114.373H341.377" stroke="black" stroke-width="4" stroke-linecap="round"/>
</svg>
`;
